export default [
    {
        img: "bmw-x4.png",
        name: "BMW X4",
        price: "50",
        mark: "BMW",
        year: "2019",
        doors: "4/5",
        AC: "yes",
        transmission: 'automatic',
        fuel: "diesel"
    },
    {
        img:"bmw-530i.png",
        name: "BMW 530i",
        price: "50",
        mark: "bmw",
        year: "2017",
        doors: "4/5",
        AC: "yes",
        transmission: "automatic",
        fuel: "benzin"
    },
    {
        img: "audi-q5.png",
        name: "Audi Q5",
        price: "50",
        mark: "AUDI",
        year: "2019",
        doors: "4/5",
        AC: "yes",
        transmission: "automatic",
        fuel: "diesel"
    },
    {
        img: "audi-a6.png",
        name: "AUDI A6",
        price: "35",
        mark: "AUDI",
        year: "2013",
        doors: "4/5",
        AC: "yes",
        transmission: "manual",
        fuel: "diesel"
    },
    {
        img: "toyota-rav4.png",
        name: "Toyota RAV4",
        price: "45",
        mark: "Toyota",
        year: "2016",
        doors: "4/5",
        AC: "yes",
        transmission: "automatic",
        fuel: "hybrid benzin/electro"
    },
    {
        img: "tesla.png",
        name: "TESLA Model S",
        price: "40",
        mark: "TESLA",
        year: "2016",
        doors: "4/5",
        AC: "yes",
        transmission: "automatic",
        fuel: "electro"
    }
]